import { useEffect, useState } from 'react';
import { getValueByID } from '@/utils/arrayHelper';

export default function useAuthentication() {
  const [authToken, setAuthToken] = useState<string>();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [headers, setHeaders] = useState<any[] | undefined>();
  const [cookies, setCookies] = useState<any[] | undefined>();

  useEffect(() => {
    const authTokenCookie = getValueByID(cookies, 'at');
    setAuthToken(authTokenCookie);
    const newIsAuthenticated = !!authTokenCookie;
    setIsAuthenticated(newIsAuthenticated);
  }, [cookies, headers, setAuthToken, setIsAuthenticated]);

  return {
    authToken,
    setAuthToken,
    isAuthenticated,
    setHeaders,
    setCookies,
    headers,
    cookies
  };
}